module.exports = __webpack_public_path__ + "static/noimage-0383a250e987fe737edbf2518f208bc7.jpg";